import React from "react";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const GroheCartBackButton = (props) => {
  const {backButtonClick} = props;
  return (
    <Button className="look-button look-button--secondary look-button--big nowrap"
            startIcon={<ChevronLeftIcon/>}
            onClick={backButtonClick}>
      <FormattedMessage id="buttons.back"/>
    </Button>
  )
};

GroheCartBackButton.propTypes = {
  backButtonClick: PropTypes.func.isRequired
}

export default GroheCartBackButton
